import {Action} from '@ngrx/store';
import {type} from '../../shared';

export const closeOrdersActionTypes = {
  ADD: type('[Close orders] Add'),
  ADD_SUCCESS: type('[Close orders] Add Success'),
  ADD_FAIL: type('[Close orders] Add Fail')
};

export class CloseOrdersAction implements Action {
  readonly type = closeOrdersActionTypes.ADD;
  constructor(public payload?: { orderUuids: string[], date: string }) {}
}

export class CloseOrdersSuccessAction implements Action {
  readonly type = closeOrdersActionTypes.ADD_SUCCESS;
  constructor(public payload?: string[] ) {}
}

export class CloseOrdersFailAction implements Action {
  readonly type = closeOrdersActionTypes.ADD_FAIL;
  constructor(public payload?: string) {}
}
